import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const ftthPanelApi = factory.get("ftth_panel");

const initialState = {
  ftth_panels: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 100,
      page: 0,
      city_id: null,
      cabinet_id: null,
      is_active: null,
    },
  },
  ftth_panel: {
    dialog: false,
    loading: false,
    form: {
      id: "",
      name: null,
      name_ar: null,
      panel_username: null,
      panel_password: null,
      city_ids: [],
    },
  },
  ftth_panel_user: {
    dialog: false,
    loading: false,
    form: {
      id: null,
      panel_username: null,
      panel_password: null,
    },
  },
};

const ftthPanelsSlice = createSlice({
  name: "ftthPanels",
  initialState,
  reducers: {
    setPanels: (state, { payload }) => {
      state.ftth_panels.data = payload.data;
      state.ftth_panels.total = payload.total;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.ftth_panels.filters = {
        ...state.ftth_panels.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.ftth_panels.filters = initialState.ftth_panels.filters;
    },
    setPanelDialog: (state, { payload }) => {
      state.ftth_panel.dialog = !state.ftth_panel.dialog;
      if (payload?.id) {
        state.ftth_panel.form.id = payload?.id || null;
        state.ftth_panel.form.name = payload?.name || null;
        state.ftth_panel.form.name_ar = payload?.name_ar || null;
        state.ftth_panel.form.city_ids = payload?.cities || [];
        state.ftth_panel.form.city_ids = payload?.cities || [];
        state.ftth_panel.form.panel_password = "";
        state.ftth_panel.form.panel_username = "";
      }
      if (!state.ftth_panel.dialog) {
        state.ftth_panel.form = initialState.ftth_panel.form;
      }
    },
    setPanelUserDialog: (state, { payload }) => {
      state.ftth_panel_user.dialog = !state.ftth_panel_user.dialog;
      if (payload) {
        state.ftth_panel_user.form.id = payload || "";
        state.ftth_panel_user.form.panel_password = "";
        state.ftth_panel_user.form.panel_username = "";
      }
      if (!state.ftth_panel_user.dialog) {
        state.ftth_panel_user.form = initialState.ftth_panel_user.form;
      }
    },
  },
});

export const {
  setPanels,
  setLoading,
  setFilters,
  resetFilters,
  setPanelDialog,
  setPanelUserDialog,
} = ftthPanelsSlice.actions;

export default ftthPanelsSlice.reducer;

export const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().ftthPanel.ftth_panels.filters;
    dispatch(setLoading("ftth_panels"));
    const custom_filters = {
      ...filters,
      cabinet_id: filters.cabinet_id?.id || null,
      city_id: filters.city_id?.id || null,
    };
    const res = await ftthPanelApi.index(custom_filters);
    dispatch(setPanels(res.data));
    dispatch(setLoading("ftth_panels"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors,
        type: "error",
      })
    );
    dispatch(setLoading("ftth_panels"));
    throw new Error(err);
  }
};
export const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("ftth_panel"));
    const city_ids = data.city_ids.map((item) => item.id);
    await ftthPanelApi.create({
      ...data,
      city_ids,
    });
    dispatch(setLoading("ftth_panel"));
    dispatch(
      showNotification({
        message: "تم الحفظ بنجاح",
        type: "success",
      })
    );
    dispatch(setPanelDialog());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("ftth_panel"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("ftth_panel"));
    const city_ids = data.city_ids.map((item) => item.id);
    await ftthPanelApi.update({
      id: data.id,
      name: data.name,
      name_ar: data.name_ar,
      city_ids,
    });
    dispatch(setLoading("ftth_panel"));
    dispatch(
      showNotification({
        message: "تم الحفظ بنجاح",
        type: "success",
      })
    );
    dispatch(setPanelDialog());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("ftth_panel"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const updateUserPanel = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("ftth_panel_user"));
    await ftthPanelApi.updateUserPanel(data);
    dispatch(setLoading("ftth_panel_user"));
    dispatch(
      showNotification({
        message: "تم الحفظ بنجاح",
        type: "success",
      })
    );
    dispatch(setPanelUserDialog());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("ftth_panel_user"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const FtthPanelActions = {
  index,
  create,
  update,
  updateUserPanel,
};
